exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".gridClass {\n  margin: 0px !important;\n}\n.cursorPointer {\n  cursor: pointer;\n}\n.inlineBlockWithFloatLeft {\n  display: inline-block;\n  float: left;\n}\n.closeIconCss {\n  display: inline-block;\n  float: right;\n  line-height: 35px;\n}\n.backBtn {\n  color: #4b8bb1;\n}\n.session-header-divider {\n  margin-left: 20px;\n  margin-right: 15px;\n  font-size: 45px;\n  display: inline-block;\n  height: 40px;\n  padding-top: 6px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/addSessionModal.less
// module id = 3122
// module chunks = 0